<template>
<div class="crop-group__container">
  <ul class="crop-group__list">
    <crop-group-item
    v-for="cropGroupItem in cropGroupList"
    :key="cropGroupItem" :cropGroupItem="cropGroupItem"
    />
  </ul>
</div>
</template>

<script>
import CropGroupItem from '@/components/industry/CropGroupItems.vue';

export default {
  data() {
    return {
      cropGroupList: [{
        pic: '/images/industry/crop/corn.jpg',
        title: 'ЗЕРНОВЫЕ',
        text: 'К этой группе растений относятся пшеница, рис, рожь, гречиха, кукуруза, просо, ячмень и другие культуры. Их посевы занимают половину всех посевных площадей, а в некоторых странах (например, в Японии) даже больше.',
        class: 'item-1',
      },
      {
        pic: '/images/industry/crop/beans.jpg',
        title: 'ЗЕРНОБОБОВЫЕ',
        text: 'По потреблению они стоят на втором месте после зерновых. Основными культурами являются соя, фасоль, горох, бобы, чечевица и другие. Зернобобовые растения восполняют недостаток протеина в продуктах питания человека.',
        class: 'item-2',
      },
      {
        pic: '/images/industry/crop/potato.jpg',
        title: 'ТЕХНИЧЕСКИЕ',
        text: 'В эту группу входят крахмалоносные и сахароносные культуры:',
        class: 'item-3',
        kindsShow: true,
        cropKinds: [{
          text: '<b>Крахмалоносные.</b> Корне- и клубнеплодные растения (картофель, батат, ямс, таро, маниока и другие) обеспечивают питание людей, но по назначению считаются техническими. Повсеместное распространение растений из этой подгруппы объясняется их высокой продуктивностью, отличными вкусовыми и кормовыми характеристиками, а также универсальностью использования.',
        },
        {
          text: '<b>Сахароносные.</b> Они являются основным сырьем для получения сахара. В группу входят сахарные свекла и тростник, сахарная пальма, виноград, сахарная кукуруза и некоторые другие культуры. Для масштабного производства сахаров интерес представляют первые две культуры.',
        }],
      },
      {
        pic: '/images/industry/crop/sunflower.jpg',
        title: 'ЭФИРНОМАСЛИЧНЫЕ И МАСЛИЧНЫЕ',
        text: 'К ним относятся растения, в семенах или плодах которых накапливаются в большом количестве жирные и эфирные масла: арахис, подсолнечник, кунжут, клещевина, рапс, горчица, анис, тмин, шалфей, роза и другие.',
        class: 'item-4',
      },
      {
        pic: '/images/industry/crop/cotton.jpg',
        title: 'ПРЯДИЛЬНЫЕ',
        text: 'Их выращивают для получения растительных волокон. Помимо волокна некоторые прядильные растения дают семена, богатые жирными маслами. Наибольшее распространение имеют хлопчатник, лен, капок, джут, рами, кенаф, конопля, сизаль.',
        class: 'item-5',
      },
      {
        pic: '/images/industry/crop/feed.jpg',
        title: 'КОРМОВЫЕ',
        text: 'Незаменимы в создании надежной кормовой основы животноводства. В растениеводстве это достаточно обширная группа культур, в состав которой входят: ',
        class: 'item-6',
        kindsShow: true,
        cropKinds: [
          {
            text: 'кормовые (вика, люцерна, клевер)',
          },
          {
            text: 'силосные (кукуруза, подсолнечник)',
          },
          {
            text: 'корнеплоды (морковь, кормовая свекла)',
          },
          {
            text: 'бахчевые (арбуз, тыква)',
          },
        ],
      },
      ],
    };
  },
  components: {
    CropGroupItem,

  },
};
</script>

<style lang="scss" scoped>
$light-gray: #EEEEEE;

.crop-group {
  &__container {
  position: relative;
    padding: 0 145px 60px;
    &:deep(.product-background__right) {
    top: 90%;
    }
    @media (max-width: 1358px) {
      padding: 0 50px 60px;
    }
    @media (max-width: 1090px) {
      padding: 50px 50px 60px;
    }
    @media (max-width: 1090px) {
      padding: 80px 50px 60px;
    }

    @media (max-width: 480px) {
      padding: 80px 0 60px;
    }
  }

  &__list {
    position: relative;
    color: $light-gray;
    z-index: 2;
    display: grid;
    grid-gap: 50px;
    grid-template-areas:
      "a a b b"
      "c c c c"
      "d d e e"
      "f f f .";
    @media (max-width: 1090px) {
      grid-gap: 100px 30px;
    }
    @media (max-width: 780px) {
      grid-template-areas:
      "a"
      "b"
      "c"
      "d"
      "e"
      "f";
    }
    }
}
</style>
